import React from 'react';
import { Link } from 'react-router-dom';
import { HouseIcon, PhoneIcon } from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';
import { company } from '../../data/company';
export function CtaBand() {
  const {
    t
  } = useLanguage();
  return <section className="bg-brand-700 py-16 md:py-20" aria-labelledby="cta-band-title" data-id="element-268" data-mp="2x5royo891r3b">
      <div className="mx-auto max-w-3xl px-4 text-center sm:px-6 lg:px-8" data-id="element-269" data-mp="2s6x1va391gde">
        <span className="inline-flex h-14 w-14 items-center justify-center rounded-full bg-white/15 text-white" data-id="element-270" data-mp="24frnz0gvcy5q">
          <HouseIcon className="h-7 w-7" aria-hidden="true" data-id="element-271" data-mp="1zi9e97v12ewo" />
        </span>
        <h2 id="cta-band-title" className="mt-6 font-display text-3xl font-extrabold leading-tight tracking-tight text-white md:text-[2.75rem]" data-id="element-272" data-mp="2ee75cbq3gt21">
          {t('ctaBand.title')}
        </h2>
        <p className="mt-4 text-lg text-white/85" data-id="element-273" data-mp="3pqrjfsexu85u">{t('ctaBand.sub')}</p>
        <div className="mt-9 flex flex-col justify-center gap-3 sm:flex-row" data-id="element-274" data-mp="3ksgarl0dq3p7">
          <Link to="/#contact" className="inline-flex items-center justify-center rounded-md bg-cta px-7 py-4 text-base font-bold text-white shadow-lg transition-colors duration-200 ease-smooth hover:bg-cta-dark" data-id="element-275" data-mp="2vm5padyxkfc1">
            {t('cta.scheduleInspection')}
          </Link>
          <a href={company.phoneHref} className="inline-flex items-center justify-center gap-2 rounded-md border-2 border-white px-7 py-4 text-base font-bold text-white transition-colors duration-200 ease-smooth hover:bg-white hover:text-brand-800" data-id="element-276" data-mp="39loqemtbqqeu">
            <PhoneIcon className="h-5 w-5" aria-hidden="true" data-id="element-277" data-mp="2lvaxku2x0nj7" />
            {t('cta.call')} {company.phone}
          </a>
        </div>
      </div>
    </section>;
}